<script lang="ts">
    import { Col,Progress } from "sveltestrap";
    import { ProgressBarsstates } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Card cardHeaderprops="pb-0" CardBodyprops="progress-showcase row" headerTitle={ProgressBarsstates} headerContent="Use state utility classes to change the appearance of individual progress bars.">
  <div slot="contentbody">
    <Col>
      <Progress class="lg-progress-bar" value={25} color="primary">
      </Progress>
      <Progress class="lg-progress-bar" value={50} color="secondary">
      </Progress>
      <Progress class="lg-progress-bar" value={75} color="success">
      </Progress>
      <Progress class="lg-progress-bar" value={100} color="info">
      </Progress>
    </Col>
  </div>
</Card>
